import { ContentClient } from '@/clients/ContentClient';
import { defineStore } from 'pinia';

export const useLibraryStore = defineStore('library', {
    state: () => ({
        library:  []
    }),
    getters: {
        allLibrary(state) {
            return state.library;
        }
    },
    actions: {
        async getLibraryContent() {
            let response = await ContentClient.getLibraryContent();
            this.library = response.data.list;
        },
    },
})
